module.exports = require("path");


/*****************
 ** WEBPACK FOOTER
 ** external "path"
 ** module id = 3
 ** module chunks = 0
 **/